let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gVlo8")).then(() => parcelRequire('hbela'));